function GMapIconDark() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.625 28.6636V6.78857"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.375 21.3716V31.4287"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.125 19.9135V27.6896C31.1264 28.3164 30.7258 28.8735 30.1312 29.0719C28.2392 29.7027 24.1872 31.0536 22.8292 31.5064C22.5319 31.6055 22.2104 31.6047 21.9136 31.5042L14.0862 28.8947C13.7868 28.7949 13.4632 28.7949 13.1638 28.8947L6.79455 31.0181C6.34983 31.1663 5.86095 31.0917 5.48065 30.8176C5.10035 30.5436 4.875 30.1034 4.875 29.6346V10.5988C4.875 9.97116 5.27665 9.41388 5.87212 9.21537L12.7026 6.93827C13.3013 6.73868 13.9486 6.73868 14.5474 6.93827L16.5417 7.60308"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9167 10.4341C20.9167 12.8236 23.5242 15.3761 25.0117 16.6383C25.5991 17.116 26.4411 17.116 27.0285 16.6383C28.5175 15.3761 31.125 12.8236 31.125 10.4341"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0223 10.0697C26.2234 10.0705 26.3859 10.2341 26.3854 10.4352C26.3849 10.6364 26.2215 10.7991 26.0203 10.7988C25.8192 10.7986 25.6562 10.6354 25.6562 10.4343C25.6557 10.3372 25.6942 10.2439 25.763 10.1754C25.8318 10.1068 25.9252 10.0688 26.0223 10.0697"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9167 10.4342V10.4342C20.9167 7.61529 23.2019 5.33008 26.0208 5.33008V5.33008C28.8398 5.33008 31.125 7.61529 31.125 10.4342V10.4342"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GMapIconLight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M13.625 28.1582V6.2832"
        stroke="#202D38"
        strokeOpacity={0.4}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.375 20.8672V30.9243"
        stroke="#202D38"
        strokeOpacity={0.4}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.125 19.4082V27.1842C31.1264 27.811 30.7258 28.3681 30.1312 28.5665C28.2392 29.1973 24.1872 30.5482 22.8292 31.0011C22.5319 31.1002 22.2104 31.0994 21.9136 30.9988L14.0862 28.3893C13.7868 28.2895 13.4632 28.2895 13.1638 28.3893L6.79455 30.5127C6.34983 30.6609 5.86095 30.5864 5.48065 30.3123C5.10035 30.0382 4.875 29.598 4.875 29.1292V10.0935C4.875 9.46578 5.27665 8.90851 5.87212 8.71L12.7026 6.4329C13.3013 6.2333 13.9486 6.2333 14.5474 6.4329L16.5417 7.09771"
        stroke="#202D38"
        strokeWidth="2"
        strokeOpacity={0.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9167 9.92969C20.9167 12.3192 23.5242 14.8717 25.0117 16.1339C25.5991 16.6116 26.4411 16.6116 27.0285 16.1339C28.5175 14.8717 31.125 12.3192 31.125 9.92969"
        stroke="#202D38"
        strokeOpacity={0.4}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0223 9.56479C26.2234 9.56559 26.3859 9.72918 26.3854 9.93034C26.3849 10.1315 26.2215 10.2942 26.0203 10.294C25.8192 10.2937 25.6562 10.1305 25.6562 9.92937C25.6557 9.83227 25.6942 9.73901 25.763 9.67049C25.8318 9.60196 25.9252 9.56388 26.0223 9.56479"
        stroke="#202D38"
        strokeOpacity={0.4}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9167 9.92936V9.92936C20.9167 7.11041 23.2019 4.8252 26.0208 4.8252V4.8252C28.8398 4.8252 31.125 7.11041 31.125 9.92936V9.92936"
        stroke="#202D38"
        strokeOpacity={0.4}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function GMapIcon({
  mode = 'dark',
}: {
  mode?: 'light' | 'dark';
}) {
  return <>{mode === 'dark' ? <GMapIconDark /> : <GMapIconLight />}</>;
}
